export const siteInfo = {
  name: "91黑料吃瓜",
  tagline: "全网黑料视频聚合平台",
  slogan: "看最新爆料视频，追最热黑料吃瓜，一站满足你的吃瓜需求",
  description: "91黑料吃瓜是全网领先的黑料视频聚合平台，专注整合91吃瓜在线观看与91吃瓜视频在线观看资源。每日实时更新最新黑料视频、爆料视频，涵盖娱乐圈、网红圈、社会热点等多个领域，为用户提供便捷流畅的在线播放体验。站内已收录超过2万条黑料视频，日均更新50+条新鲜爆料，覆盖国内外各大社交平台热门话题。无论你是资深吃瓜群众还是刚入圈的瓜友，这里都是你获取第一手黑料的最佳选择。当前站内热点聚焦娱乐圈近期大瓜事件，多视角多来源追踪，不遗漏任何细节。",
  stats: [
    { label: "累计收录视频", value: "20,000+" },
    { label: "日均更新", value: "50+条" },
    { label: "覆盖话题", value: "300+类" },
  ],
  ctaPrimary: { text: "立即看瓜", href: "#media" },
  ctaSecondary: { text: "我要爆料", href: "#contact" },
};

export const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "焦点专题", href: "#carousel" },
  { label: "视频专区", href: "#media" },
  { label: "热门话题", href: "#topics" },
  { label: "最新快讯", href: "#updates" },
  { label: "热门图文", href: "#cards" },
  { label: "投稿爆料", href: "#contact" },
];

export const contactData = {
  title: "投稿爆料",
  subtitle: "有料你就来，一起吃大瓜",
  description: "手上有独家黑料视频或爆料线索？欢迎通过以下方式联系我们。我们保护每一位爆料人的隐私安全，严格匿名处理所有投稿信息。你的爆料可能成为下一个全网热搜！",
  items: [
    { icon: "ri-mail-line", label: "爆料邮箱", value: "toutiao@91heilia.com" },
    { icon: "ri-wechat-line", label: "微信投稿", value: "heilia91" },
    { icon: "ri-shield-check-line", label: "隐私承诺", value: "严格匿名 · 绝不泄露" },
  ],
};

export const appData = {
  title: "手机看瓜",
  subtitle: "随时随地，不错过任何一个瓜",
  description: "91黑料吃瓜移动端适配完美，无需下载APP，浏览器打开即可畅享所有黑料视频。支持 iOS、Android 全平台访问，流量优化，省流模式自动开启。加载迅速，播放流畅，让你在地铁上、午休时、睡前都能轻松吃瓜。",
  features: ["免安装即开即看", "全平台自适应", "省流模式", "夜间护眼", "推送热点提醒"],
  qrLabel: "扫码访问",
};

export const featuresData = {
  title: "平台优势",
  subtitle: "为什么千万瓜友选择91黑料吃瓜",
  items: [
    {
      icon: "ri-flashlight-line",
      title: "极速更新",
      description: "24小时全天候监控全网热点，重大爆料事件15分钟内上线，确保你永远是第一个吃瓜的人。",
    },
    {
      icon: "ri-stack-line",
      title: "海量资源",
      description: "收录超过两万条91吃瓜视频，覆盖娱乐圈、网红圈、社会事件等300+话题分类，你想看的这里都有。",
    },
    {
      icon: "ri-shield-user-line",
      title: "匿名保护",
      description: "投稿爆料全程匿名处理，不记录任何个人信息，通信加密传输，守护爆料人的安全与隐私。",
    },
    {
      icon: "ri-smartphone-line",
      title: "多端适配",
      description: "无需下载安装，手机电脑平板全平台自适应，随时随地打开浏览器就能畅享流畅播放体验。",
    },
    {
      icon: "ri-filter-3-line",
      title: "智能推荐",
      description: "基于你的浏览偏好智能聚合相关黑料视频，越看越懂你，打造专属的吃瓜内容流。",
    },
  ],
};

export const carouselData = {
  title: "焦点专题",
  subtitle: "本周最受关注的六大黑料事件，一网打尽",
  items: [
    {
      tag: "娱乐圈",
      title: "某顶流男星深夜密会事件全记录",
      excerpt: "多角度实拍视频流出，三小时完整时间线还原，独家对话知情人。",
      image: "https://readdy.ai/api/search-image?query=cinematic%20dramatic%20dark%20atmosphere%20with%20warm%20spotlight%20on%20a%20stage%20curtain%2C%20mysterious%20vibe%2C%20entertainment%20industry%20theme%2C%20golden%20and%20crimson%20tones%2C%20high%20contrast%2C%20theatrical%20lighting%2C%20abstract%20concept&width=800&height=500&seq=carousel-01&orientation=landscape",
    },
    {
      tag: "网红圈",
      title: "千万粉网红直播翻车完整录像",
      excerpt: "直播间意外事件完整回放，网友逐帧分析细节，品牌方连夜发声明。",
      image: "https://readdy.ai/api/search-image?query=dramatic%20streaming%20studio%20scene%20with%20warm%20ambient%20lighting%2C%20ring%20light%20glow%2C%20mysterious%20atmosphere%2C%20dark%20background%20with%20golden%20accents%2C%20live%20broadcast%20concept%2C%20red%20and%20amber%20tones&width=800&height=500&seq=carousel-02&orientation=landscape",
    },
    {
      tag: "社会热点",
      title: "某知名企业高管内部录音流出",
      excerpt: "长达47分钟的会议录音文字版公开，涉及多项敏感话题，公司股价应声下跌。",
      image: "https://readdy.ai/api/search-image?query=corporate%20boardroom%20dramatic%20scene%20with%20warm%20dim%20lighting%2C%20leather%20chairs%2C%20mysterious%20atmosphere%2C%20confidential%20documents%20vibe%2C%20cinematic%20golden%20and%20dark%20tones%2C%20high%20stakes%20meeting&width=800&height=500&seq=carousel-03&orientation=landscape",
    },
    {
      tag: "娱乐圈",
      title: "某女星婚变内幕独家梳理",
      excerpt: "从社交动态到财产分割，完整时间线整理六大疑点，知情人逐一回应。",
      image: "https://readdy.ai/api/search-image?query=romantic%20drama%20scene%20with%20split%20composition%2C%20warm%20golden%20light%20on%20one%20side%20and%20shadow%20on%20other%2C%20emotional%20atmosphere%2C%20red%20rose%20petals%2C%20cinematic%20lighting%2C%20dramatic%20contrast&width=800&height=500&seq=carousel-04&orientation=landscape",
    },
    {
      tag: "网红圈",
      title: "带货一哥选品内幕大起底",
      excerpt: "前员工匿名曝光选品流程与佣金结构，多品牌回应引发连锁反应。",
      image: "https://readdy.ai/api/search-image?query=ecommerce%20warehouse%20dramatic%20lighting%2C%20products%20under%20spotlight%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20crimson%20tones%2C%20shelves%20of%20boxes%2C%20cinematic%20investigation%20vibe&width=800&height=500&seq=carousel-05&orientation=landscape",
    },
    {
      tag: "社会热点",
      title: "某事件完整监控视频首度公开",
      excerpt: "多个角度监控画面同步对比，时间戳精确到秒，此前流传说法被逐一证伪。",
      image: "https://readdy.ai/api/search-image?query=security%20camera%20footage%20aesthetic%2C%20multiple%20screen%20grid%20layout%2C%20dramatic%20warm%20lighting%2C%20surveillance%20concept%2C%20mysterious%20urban%20night%20scene%2C%20golden%20and%20dark%20tones&width=800&height=500&seq=carousel-06&orientation=landscape",
    },
  ],
};

export const mediaData = {
  title: "视频专区",
  subtitle: "最新黑料视频在线播放，高清流畅无需等待",
  items: [
    {
      title: "某综艺录制现场冲突完整版",
      views: "128.5万",
      duration: "08:24",
      tag: "热门",
      image: "https://readdy.ai/api/search-image?query=TV%20show%20recording%20studio%20dramatic%20moment%2C%20warm%20stage%20lighting%2C%20tension%20atmosphere%2C%20golden%20and%20crimson%20tones%2C%20behind%20the%20scenes%20entertainment%2C%20video%20thumbnail%20style&width=640&height=360&seq=media-01&orientation=landscape",
    },
    {
      title: "网红直播间意外对话全记录",
      views: "96.3万",
      duration: "15:42",
      tag: "新",
      image: "https://readdy.ai/api/search-image?query=streamer%20live%20room%20dramatic%20moment%2C%20ring%20light%20glow%2C%20surprised%20expression%2C%20warm%20ambient%20lighting%2C%20golden%20and%20amber%20tones%2C%20video%20thumbnail%20style%2C%20cinematic&width=640&height=360&seq=media-02&orientation=landscape",
    },
    {
      title: "某公司年会私密视频流出",
      views: "215.7万",
      duration: "22:08",
      tag: "爆",
      image: "https://readdy.ai/api/search-image?query=corporate%20party%20dramatic%20scene%2C%20warm%20dim%20banquet%20lighting%2C%20mysterious%20atmosphere%2C%20golden%20chandeliers%2C%20red%20and%20amber%20tones%2C%20video%20thumbnail%20style&width=640&height=360&seq=media-03&orientation=landscape",
    },
    {
      title: "圈内人士深夜私局偷拍",
      views: "187.2万",
      duration: "11:35",
      tag: "热",
      image: "https://readdy.ai/api/search-image?query=dark%20private%20club%20VIP%20room%2C%20warm%20moody%20lighting%2C%20mysterious%20silhouettes%2C%20golden%20table%20lamps%2C%20leather%20sofa%2C%20dramatic%20atmosphere%2C%20video%20thumbnail%20style&width=640&height=360&seq=media-04&orientation=landscape",
    },
  ],
};

export const topicsData = {
  title: "热门话题",
  subtitle: "全网吃瓜群众正在热议的话题标签",
  items: [
    { name: "某顶流塌房", heat: "999万+", tag: "爆" },
    { name: "直播间翻车合集", heat: "856万+", tag: "热" },
    { name: "明星婚变内幕", heat: "742万+", tag: "热" },
    { name: "带货选品黑幕", heat: "698万+", tag: "新" },
    { name: "综艺录制事故", heat: "621万+", tag: "热" },
    { name: "高管录音泄露", heat: "587万+", tag: "爆" },
    { name: "网红人设崩塌", heat: "534万+", tag: "热" },
    { name: "年会私密视频", heat: "498万+", tag: "新" },
    { name: "圈内人士爆料", heat: "445万+", tag: "热" },
    { name: "社交平台大瓜", heat: "412万+", tag: "新" },
  ],
};

export const indexData = {
  title: "专题合集",
  subtitle: "精选分类，快速找到你想吃的瓜",
  items: [
    { icon: "ri-movie-line", name: "娱乐圈大瓜", count: "1,286条", color: "primary" },
    { icon: "ri-live-line", name: "网红翻车实录", count: "952条", color: "accent" },
    { icon: "ri-building-line", name: "企业内幕曝光", count: "647条", color: "primary" },
    { icon: "ri-government-line", name: "社会热点追踪", count: "1,834条", color: "accent" },
    { icon: "ri-user-voice-line", name: "匿名爆料专区", count: "523条", color: "primary" },
    { icon: "ri-fire-line", name: "本周最热", count: "189条", color: "accent" },
    { icon: "ri-time-line", name: "24小时新瓜", count: "67条", color: "primary" },
    { icon: "ri-star-line", name: "经典回顾", count: "3,241条", color: "accent" },
    { icon: "ri-archive-line", name: "全部视频库", count: "20,856条", color: "primary" },
  ],
};

export const faqData = {
  title: "常见问答",
  subtitle: "关于91黑料吃瓜，你想知道的都在这里",
  items: [
    {
      question: "91黑料吃瓜是什么平台？",
      answer: "91黑料吃瓜是一个专注聚合91吃瓜在线观看与91吃瓜视频在线观看资源的黑料视频平台。我们整合全网最新黑料视频和爆料视频，涵盖娱乐圈、网红圈、社会热点等多个领域，为用户提供一站式吃瓜体验，所有视频均可直接在线播放。",
    },
    {
      question: "如何确保投稿爆料的隐私安全？",
      answer: "我们采用端到端加密通信技术处理所有投稿，不记录任何可识别个人信息。投稿渠道全程匿名，内容发布前会进一步脱敏处理。平台运营多年从未发生过爆料人信息泄露事件，安全可靠。",
    },
    {
      question: "视频为什么可以免费在线观看？",
      answer: "91黑料吃瓜通过广告合作与流量变现维持运营，不向用户收取任何费用。所有91吃瓜视频均可免费在线播放，无需注册会员，打开即看。未来即使推出增值服务，基础视频观看也将始终保持免费。",
    },
    {
      question: "手机上观看视频效果如何？",
      answer: "平台针对移动端做了深度优化，支持 iOS、Android 全平台自适应访问。无需下载任何APP，浏览器直接打开即可流畅观看。智能省流模式自动识别网络环境，低带宽下也能稳定播放，流量消耗仅为同类平台的60%。",
    },
  ],
};

export const commentsData = {
  title: "瓜友热评",
  subtitle: "吃瓜群众都在聊什么",
  items: [
    {
      avatar: "瓜",
      nickname: "资深吃瓜人",
      time: "3小时前",
      content: "这个平台太强了，好多外面找不到的视频这里都有！更新速度也是真的快，上次那个综艺事故，别的地方还在传文字版，这里视频都出来了。每天必刷的网站没有之一。",
      likes: "2.3k",
    },
    {
      avatar: "料",
      nickname: "匿名爆料侠",
      time: "5小时前",
      content: "投过一次料，处理速度很快，而且真的全程匿名。发出来之后当天就爆了，看着自己爆的料冲上热搜还挺有成就感的哈哈。平台对爆料人的保护确实到位。",
      likes: "1.8k",
    },
    {
      avatar: "看",
      nickname: "吃瓜一线选手",
      time: "8小时前",
      content: "页面干净没广告弹窗这一点必须点赞！播放器也很流畅，不用等缓冲。分类也清楚，想找哪个圈的瓜都很方便。建议加个夜间模式，晚上躺床上吃瓜眼睛不累。",
      likes: "956",
    },
  ],
};

export const aboutData = {
  title: "关于我们",
  subtitle: "全网领先的黑料视频聚合平台",
  intro: "91黑料吃瓜成立于2019年，是全网最早专注黑料视频聚合的平台之一。六年来我们始终坚持\"第一时间、第一手料\"的运营理念，累计收录黑料视频超过两万条，总播放量突破50亿次，服务超过千万吃瓜用户。平台以91吃瓜在线观看和91吃瓜视频在线观看为核心功能，覆盖娱乐圈、网红圈、社会热点、企业内幕等多元领域。我们拥有专业的内容审核与分发团队，确保每一条视频真实可靠、来源可溯，同时严格保护爆料人隐私安全。",
  highlights: [
    { value: "50亿+", label: "累计播放量" },
    { value: "1000万+", label: "服务用户" },
    { value: "2万+", label: "收录视频" },
    { value: "6年", label: "运营时间" },
  ],
};

export const updatesData = {
  title: "最新快讯",
  subtitle: "实时追踪，分秒必争的吃瓜前线",
  items: [
    {
      time: "12分钟前",
      tag: "突发",
      title: "某知名导演被曝片场不当行为，多名演员发声",
      summary: "一段拍摄于去年夏天的片场视频今日流出，画面显示导演对演员进行不当指导。目前已有多位圈内人士转发评论，事件持续发酵中。",
    },
    {
      time: "28分钟前",
      tag: "跟进",
      title: "顶流塌房事件最新进展：品牌方集体解约",
      summary: "继昨日爆料视频曝光后，截至发稿已有7家品牌宣布终止合作。据业内人士估算，解约总金额或超两亿元，创下近年娱乐圈解约记录。",
    },
    {
      time: "1小时前",
      tag: "独家",
      title: "某MCN机构内部管理制度曝光",
      summary: "一份标注为某头部MCN机构内部文件今日流出，详细列明旗下网红的管理考核体系，其中包括多项争议条款。文件真实性正在核实中。",
    },
    {
      time: "2小时前",
      tag: "热点",
      title: "直播带货翻车合集播放量破千万",
      summary: "本站整理的近期直播带货翻车视频合集上线仅三天即突破千万播放，其中某知名主播的片段单条播放量高达380万，弹幕评论超五万条。",
    },
    {
      time: "3小时前",
      tag: "爆料",
      title: "匿名投稿：某综艺节目剪辑内幕",
      summary: "自称曾参与某热门综艺后期制作的匿名人士投稿，详细揭露节目组通过恶意剪辑制造矛盾的套路，并列出了具体的剪辑时间线和操作方式。",
    },
    {
      time: "5小时前",
      tag: "跟进",
      title: "企业高管录音事件：公司回应来了",
      summary: "针对昨日流出的内部会议录音，涉事企业于今日下午发布声明，称录音内容\"断章取义、恶意剪辑\"，并表示已向公安机关报案。但网友发现声明中多处细节与录音不符。",
    },
    {
      time: "7小时前",
      tag: "新瓜",
      title: "某女星离婚协议关键条款曝光",
      summary: "一份据称来自知情人士的离婚协议摘要今日在网上流传，涉及巨额财产分割与子女抚养权争议条款。女方工作室暂未回应，男方代理人称\"不便评论\"。",
    },
  ],
};

export const rankingData = {
  title: "吃瓜榜单",
  subtitle: "本周热度最高的黑料视频排行",
  items: [
    { rank: 1, title: "某顶流男星深夜密会全程录像", heat: "本周播放 528万", trend: "up" },
    { rank: 2, title: "带货一哥选品内幕完整曝光", heat: "本周播放 467万", trend: "up" },
    { rank: 3, title: "女星婚变财产分割协议细节", heat: "本周播放 398万", trend: "up" },
    { rank: 4, title: "某企业高管内部会议录音", heat: "本周播放 352万", trend: "new" },
    { rank: 5, title: "网红直播间翻车视频集锦", heat: "本周播放 315万", trend: "up" },
    { rank: 6, title: "综艺录制现场冲突完整版", heat: "本周播放 289万", trend: "down" },
  ],
};

export const cardsData = {
  title: "热门图文",
  subtitle: "深度爆料图文，吃瓜也要吃明白",
  items: [
    {
      tag: "深度",
      title: "起底某流量明星的商业版图：从练习生到资本玩家",
      excerpt: "从韩国练习生到国内顶流，再到幕后资本运作，我们用时间线还原了一个偶像的商业进化之路...",
      image: "https://readdy.ai/api/search-image?query=business%20empire%20concept%20art%2C%20dramatic%20warm%20lighting%2C%20skyscraper%20silhouette%2C%20golden%20hour%20tones%2C%20power%20and%20ambition%20theme%2C%20cinematic%20composition&width=600&height=400&seq=cards-01&orientation=landscape",
    },
    {
      tag: "盘点",
      title: "2026上半年十大翻车网红：从人设崩塌到彻底凉凉",
      excerpt: "半年时间十位千万级网红先后翻车，我们整理了他们从巅峰到谷底的完整轨迹，每一个故事都让人唏嘘...",
      image: "https://readdy.ai/api/search-image?query=dramatic%20falling%20concept%20with%20warm%20golden%20and%20dark%20tones%2C%20abstract%20domino%20effect%2C%20social%20media%20icons%20crumbling%2C%20cinematic%20atmosphere%2C%20high%20contrast&width=600&height=400&seq=cards-02&orientation=landscape",
    },
    {
      tag: "独家",
      title: "某选秀节目投票造假内幕：知情人士万字长文",
      excerpt: "一位自称参与过三届选秀节目制作的业内人士，以万字长文详细揭露了投票造假的完整产业链...",
      image: "https://readdy.ai/api/search-image?query=talent%20show%20stage%20dramatic%20lighting%2C%20spotlight%20on%20empty%20center%2C%20mysterious%20atmosphere%2C%20warm%20golden%20tones%2C%20reality%20show%20concept%2C%20dark%20edges&width=600&height=400&seq=cards-03&orientation=landscape",
    },
    {
      tag: "追踪",
      title: "某明星偷税案全记录：从举报到官方通报完整时间线",
      excerpt: "从匿名举报信曝光到税务机关正式通报，我们按小时整理了这起震惊娱乐圈的案件全过程...",
      image: "https://readdy.ai/api/search-image?query=legal%20documents%20dramatic%20scene%2C%20warm%20desk%20lamp%20lighting%2C%20investigation%20concept%2C%20golden%20and%20dark%20tones%2C%20official%20papers%20aesthetic%2C%20cinematic%20mood&width=600&height=400&seq=cards-04&orientation=landscape",
    },
    {
      tag: "分析",
      title: "MCN机构割韭菜大全：签约陷阱、分成比例与解约困局",
      excerpt: "深度解析国内头部MCN机构的标准合同条款，从签约到解约，为你揭开网红经济背后的残酷真相...",
      image: "https://readdy.ai/api/search-image?query=contract%20signing%20dramatic%20scene%2C%20warm%20office%20lighting%2C%20pen%20and%20documents%2C%20mysterious%20atmosphere%2C%20golden%20and%20crimson%20tones%2C%20legal%20concept%2C%20cinematic&width=600&height=400&seq=cards-05&orientation=landscape",
    },
    {
      tag: "揭秘",
      title: "娱乐圈\"对赌协议\"真相：那些年明星签过的卖身契",
      excerpt: "对赌协议在娱乐圈已是公开的秘密，但普通观众鲜少了解其运作方式。本文为你完整拆解对赌的玩法与代价...",
      image: "https://readdy.ai/api/search-image?query=gambling%20chips%20and%20contracts%20dramatic%20concept%2C%20warm%20casino%20lighting%2C%20golden%20tokens%2C%20high%20stakes%20atmosphere%2C%20dark%20and%20amber%20tones%2C%20cinematic%20composition&width=600&height=400&seq=cards-06&orientation=landscape",
    },
  ],
};